import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { SocialSecurityNumberMaskType } from '@nxtpeople/nxt-vue-library';
import { LocationQuery } from 'vue-router';
export class SocialSecurityNumberMaskTypeService {
   async getSocialSecurityNumberMaskTypes(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<SocialSecurityNumberMaskType>>>('/social-security-number-mask-types', {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }

   async getSocialSecurityNumberMaskType() {
      throw Error('Method not implemented');
   }

   async postSocialSecurityNumberMaskType() {
      throw Error('Method not implemented');
   }

   async putSocialSecurityNumberMaskType() {
      throw Error('Method not implemented');
   }

   async deleteSocialSecurityNumberMaskType() {
      throw Error('Method not implemented');
   }
}
